// @ts-strict-ignore
import type { Font } from "./types";

export const ARIAL_FONT: Font = { name: "Arial", fontFamily: "'Arial'", url: null };
export const COURIER_FONT: Font = { name: "Courier", fontFamily: "'Courier'", url: null };
export const GEORGIA_FONT: Font = { name: "Georgia", fontFamily: "'Georgia'", url: null };
export const HELVETICA_FONT: Font = { name: "Helvetica", fontFamily: "'Helvetica'", url: null };
export const LUCIDA_SANS_FONT: Font = { name: "Lucida Sans", fontFamily: "'Lucida Sans'", url: null };
export const TAHOMA_FONT: Font = { name: "Tahoma", fontFamily: "'Tahoma'", url: null };
export const TIMES_NEW_ROMAN_FONT: Font = { name: "Times New Roman", fontFamily: "'Times New Roman'", url: null };
export const TREBUCHET_MS_FONT: Font = { name: "Trebuchet MS", fontFamily: "'Trebuchet MS'", url: null };
export const VERDANA_FONT: Font = { name: "Verdana", fontFamily: "'Verdana'", url: null };
export const IMPACT_FONT: Font = { name: "Impact", fontFamily: "'Impact'", url: null };
export const DIDOT_FONT: Font = { name: "Didot", fontFamily: "'Didot'", url: null };
export const AMERICAN_TYPEWRITER_FONT: Font = {
  name: "American Typewriter",
  fontFamily: "'American Typewriter'",
  url: null,
};
export const ANDALE_MONO_FONT: Font = { name: "Andale Mono", fontFamily: "'Andale Mono'", url: null };
export const LUCIDA_CONSOLE_FONT: Font = { name: "Lucida Console", fontFamily: "'Lucida Console'", url: null };
export const MONACO_FONT: Font = { name: "Monaco", fontFamily: "'Monaco'", url: null };
export const BRADLEY_HAND_FONT: Font = { name: "Bradley Hand", fontFamily: "'Bradley Hand'", url: null };
export const BRUSH_SCRIPT_MT_FONT: Font = { name: "Brush Script MT", fontFamily: "'Brush Script MT'", url: null };
export const LUMINARI_FONT: Font = { name: "Luminari", fontFamily: "'Luminari'", url: null };
export const COMIC_SANS_MS_FONT: Font = { name: "Comic Sans MS", fontFamily: "'Comic Sans MS'", url: null };
export const COURIER_NEW_FONT: Font = { name: "Courier New", fontFamily: "'Courier New'", url: null };
export const FRANKLIN_GOTHIC_MEDIUM_FONT: Font = {
  name: "Franklin Gothic Medium",
  fontFamily: "'Franklin Gothic Medium'",
  url: null,
};
export const GENEVA_FONT: Font = { name: "Geneva", fontFamily: "'Geneva'", url: null };
export const LUCIDA_GRANDE_FONT: Font = { name: "Lucida Grande", fontFamily: "'Lucida Grande'", url: null };
export const PALATINO_FONT: Font = { name: "Palatino", fontFamily: "'Palatino'", url: null };
export const ヒラギノ角ゴ_PRO_W3_FONT: Font = {
  name: "ヒラギノ角ゴ Pro W3",
  fontFamily: "'ヒラギノ角ゴ Pro W3'",
  url: null,
};
export const メイリオ_FONT: Font = { name: "メイリオ", fontFamily: "'メイリオ'", url: null };
/**
 * These are google font options that attempt to fetch italic and font weight variants.
 * If a request weight is not available, google will only return what's available.
 */
const FONT_OPTIONS = ":ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900";
export const LOBSTER_FONT: Font = {
  name: "Lobster",
  fontFamily: "'Lobster'",
  url: "https://fonts.googleapis.com/css2?family=Lobster" + FONT_OPTIONS,
  fontWeight: {
    400: "Regular",
  },
};
export const CRIMSON_TEXT_FONT: Font = {
  name: "Crimson Text",
  fontFamily: "'Crimson Text'",
  url: "https://fonts.googleapis.com/css2?family=Crimson+Text" + FONT_OPTIONS,
  fontWeight: {
    100: "Light",
    300: "Regular",
    900: "Bold",
  },
};
export const BITTER_FONT: Font = {
  name: "Bitter",
  fontFamily: "'Bitter'",
  url: "https://fonts.googleapis.com/css2?family=Bitter" + FONT_OPTIONS,
  fontWeight: {
    300: "Light",
    400: "Regular",
    700: "Bold",
  },
};
export const DROID_SERIF_FONT: Font = {
  name: "Droid Serif",
  fontFamily: "'Droid Serif'",
  url: "https://fonts.googleapis.com/css2?family=Droid+Serif" + FONT_OPTIONS,
  fontWeight: {
    400: "Regular",
    700: "Bold",
  },
};
export const LATO_FONT: Font = {
  name: "Lato",
  fontFamily: "'Lato'",
  url: "https://fonts.googleapis.com/css2?family=Lato" + FONT_OPTIONS,
  fontWeight: {
    100: "Thin",
    300: "Light",
    400: "Regular",
    700: "Bold",
    900: "Black",
  },
};
export const OPEN_SANS_FONT: Font = {
  name: "Open Sans",
  fontFamily: "'Open Sans'",
  url: "https://fonts.googleapis.com/css2?family=Open+Sans" + FONT_OPTIONS,
  fontWeight: {
    300: "Light",
    400: "Regular",
    700: "Bold",
  },
};
export const ROBOTO_FONT: Font = {
  name: "Roboto",
  fontFamily: "'Roboto'",
  url: "https://fonts.googleapis.com/css2?family=Roboto" + FONT_OPTIONS,
  fontWeight: {
    100: "Thin",
    300: "Light",
    400: "Regular",
    700: "Bold",
    900: "Black",
  },
};
export const SOURCE_SANS_PRO_FONT: Font = {
  name: "Source Sans Pro",
  fontFamily: "'Source Sans Pro'",
  url: "https://fonts.googleapis.com/css2?family=Source+Sans+Pro" + FONT_OPTIONS,
  fontWeight: {
    100: "Thin",
    300: "Light",
    400: "Regular",
    700: "Bold",
    900: "Black",
  },
};
export const MONTSERRAT_FONT: Font = {
  name: "Montserrat",
  fontFamily: "'Montserrat'",
  url: "https://fonts.googleapis.com/css2?family=Montserrat" + FONT_OPTIONS,
  fontWeight: {
    100: "Thin",
    300: "Light",
    400: "Regular",
    700: "Bold",
    900: "Black",
  },
};
export const UBUNTU_FONT: Font = {
  name: "Ubuntu",
  fontFamily: "'Ubuntu'",
  url: "https://fonts.googleapis.com/css2?family=Ubuntu" + FONT_OPTIONS,
  fontWeight: {
    300: "Light",
    400: "Regular",
    700: "Bold",
  },
};

// These fonts do not typically contain quotes in the font-family.
export const SERIF_FONT: Font = { name: "Serif", fontFamily: "Serif", url: null };
export const SANS_SERIF_FONT: Font = { name: "Sans-serif", fontFamily: "Sans-serif", url: null };

export const BEEFREE_FONTS: Font[] = [
  ARIAL_FONT,
  COURIER_FONT,
  GEORGIA_FONT,
  HELVETICA_FONT,
  LUCIDA_SANS_FONT,
  TAHOMA_FONT,
  TIMES_NEW_ROMAN_FONT,
  TREBUCHET_MS_FONT,
  VERDANA_FONT,
  ヒラギノ角ゴ_PRO_W3_FONT,
  メイリオ_FONT,
  BITTER_FONT,
  DROID_SERIF_FONT,
  LATO_FONT,
  OPEN_SANS_FONT,
  ROBOTO_FONT,
  SOURCE_SANS_PRO_FONT,
  MONTSERRAT_FONT,
  UBUNTU_FONT,
];

export const FALLBACK_FONTS: Font[] = [
  AMERICAN_TYPEWRITER_FONT,
  ANDALE_MONO_FONT,
  ARIAL_FONT,
  BRADLEY_HAND_FONT,
  BRUSH_SCRIPT_MT_FONT,
  COURIER_FONT,
  COURIER_NEW_FONT,
  COMIC_SANS_MS_FONT,
  DIDOT_FONT,
  FRANKLIN_GOTHIC_MEDIUM_FONT,
  GENEVA_FONT,
  GEORGIA_FONT,
  IMPACT_FONT,
  LUCIDA_CONSOLE_FONT,
  LUCIDA_GRANDE_FONT,
  LUMINARI_FONT,
  MONACO_FONT,
  PALATINO_FONT,
  TAHOMA_FONT,
  TIMES_NEW_ROMAN_FONT,
  TREBUCHET_MS_FONT,
  VERDANA_FONT,
];
